import {useMemo} from 'react'
import {A1Helpers} from '../core/helpers'
import {useA1BatchesProvider} from '../../../../_gori/providers/A1BatchesProvider'
import A1_CONSTANTS from '../core/_const'

export const useA1JourneyStatus = () => {
  const {a1Batch} = useA1BatchesProvider()
  const journeyStatusLargerOrEqualCustoms = useMemo(
    () =>
      A1Helpers.checkJourneyStatus({
        statusCurrent: a1Batch?.journey_status,
        statusCheck: A1_CONSTANTS.OPTIONS_JOURNEY_STATUS.CUSTOMS.value[0] || '',
      }),
    [a1Batch?.journey_status]
  )

  const holdRejectedCount = useMemo(
    () =>
      journeyStatusLargerOrEqualCustoms && a1Batch?.held_orders > 0 ? a1Batch?.held_orders : 0,
    [a1Batch?.held_orders, journeyStatusLargerOrEqualCustoms]
  )

  return {
    journeyStatusLargerOrEqualCustoms,
    holdRejectedCount,
  }
}
